module.exports = __webpack_public_path__ + "media/img/android-icon-192x192-16463f468b2f4a48c052aebed94a9df5.png";